import Component from 'flarum/common/Component';
import icons from '../icons/duotone.json';

// A small local subset of Phosphor Duotone (MIT). No icon font or CDN request.
export default class BsiIcon extends Component {
  view() {
    const {
      name,
      className = ''
    } = this.attrs;
    return m("svg", {
      className: 'BsiIcon ' + className,
      "data-bsi-icon": name,
      viewBox: "0 0 256 256",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true",
      focusable: "false"
    }, (icons[name] || []).map(_ref => {
      let {
        tag,
        attrs
      } = _ref;
      return m(tag, attrs);
    }));
  }
}

// Native Flarum buttons accept a vnode as their icon, preserving their normal
// loading, disabled, label and keyboard behavior.
export const buttonIcon = name => m(BsiIcon, {
  name: name,
  className: "Button-icon"
});
export const pageIcons = {
  services: 'cpu',
  payment: 'credit-card',
  refund: 'arrow-u-up-left',
  terms: 'shield-check',
  contacts: 'chat-circle-dots'
};
flarum.reg.add('bsi-orders', 'forum/components/BsiIcon', BsiIcon);